export default __webpack_public_path__ + "images/credit_card_error.png";